import { get, httpDelete, post, put } from "../../services/HttpService";

export class Approvals {
  constructor(approvals = {}) {
    this.set(approvals);
  }

  /**
 * @memberof Approvals
 * @type API
 * @returns Promise
 */
  static approvals_list = (queryData = {}, config = {}) => {
    return get(`/vendor-payouts/v1/internal/approvals/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };


  approval_update = (queryData = {}) => {
    queryData = { ...queryData };
    return put(
      `/vendor-payouts/v1/internal/approvals/${this.id}/`,
      queryData,
      {}
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  // approval_action = (queryData = {}) => {
  //   queryData = { ...this.get(), ...queryData };
  //   return post(
  //     `/vendor-payouts/v1/internal/approvals/${this.id}/`,
  //     queryData,
  //     {}
  //   ).catch((error) => ({
  //     success: false,
  //     data: (error.response && error.response.data) || {},
  //     status: (error.response && error.response.status) || 400,
  //   }));
  // };

  /**
   * @memberof Approvals
   * @type Setter Method
   * @takes Approvals Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof Approvals
   * @type Getter Method
   * @returns Approvals
   */
  get = () => {
    return {
      id: this.uuid,
    };
  };
}
